import { render, staticRenderFns } from "./StatsManual.vue?vue&type=template&id=d9a9a450&scoped=true"
import script from "./StatsManual.vue?vue&type=script&lang=js"
export * from "./StatsManual.vue?vue&type=script&lang=js"
import style0 from "./StatsManual.vue?vue&type=style&index=0&id=d9a9a450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a9a450",
  null
  
)

export default component.exports